import { IFilterCommercialOffers } from "./types"

import { Button, Container, Divider, Drawer, Flex, Toogle, ToolTip } from "@ui/index"

import { IconClearClose } from "@img/icons"

import css from './ui.module.scss'


/** Фильтр - Коммерческие предложения */
export const CommercialOffersFilter = ({ 
    isOpen, filterSites,
    handleButtonCancel, handleApplyClearFilter
}: IFilterCommercialOffers) => {

    /** Выбор сайтов в окне фильтров */
    const handleSelectSites = (id: number) => {
        const updatedStatuses = filterSites.value.map(status => {
            if (status.id === id) {
                return { ...status, isSelected: !status.isSelected }
            }

            return status
        })

        filterSites.setValue(updatedStatuses)
    }


    return <>
        <Drawer isOpen={isOpen} zIndex={1001} isEsc isWrapper isWrapperBlur={false} onCancel={handleButtonCancel} maxWidth='370px' placement='right'>
            <Flex className='drawer_container'>
                <Flex flexDirection='row' alignItems='center' justifyContent='space-between' className='drawer_container-header'>
                    <h4>Фильтр...</h4>

                    <Button variant='icon' size='sm' onClick={handleButtonCancel}>
                        <IconClearClose width="20px" height="20px" />
                    </Button>
                </Flex>

                <Flex gap='4px' className='drawer_container-body'>
                    <Flex gap='20px' className='drawer_container-content'>
                        <Flex gap="4px">
                            <Divider prefix='Отобразить заявки сайта' gap="6px" />

                            <Flex gap="4px">
                                {filterSites && filterSites.value.map(item => {
                                    return (
                                        <Container key={item.id} padding="4px 3px 4px 10px" className={css['filter_toogle_container']}>
                                            <p>{item.description}:</p>
                                            <Toogle checked={item.isSelected} onChange={() => handleSelectSites(item.id)} />
                                        </Container>
                                    )
                                })}
                            </Flex>
                        </Flex>
                    </Flex>

                    <div style={{gap: '5px', display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
                        <Button variant="primaryDark" onClick={() => handleApplyClearFilter('clear')}>Очистить</Button>
                        <Button onClick={() => handleApplyClearFilter('apply')}>Применить</Button>
                    </div>
                </Flex>
            </Flex>
        </Drawer>
    </>
}
